import React from "react";
import { LoginForm } from "../components/LoginForm.jsx";

export function LoginPage({ onLoginSuccess }) {
  return (
    <div style={{
      minHeight: "100dvh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "1.5rem"
    }}>
      <div style={{
        width: "100%",
        maxWidth: "420px",
        background: "var(--bg-surface)",
        padding: "2rem",
        borderRadius: "var(--radius-lg)",
        border: "1px solid var(--border-subtle)",
        boxShadow: "var(--shadow-sheet)",
        textAlign: "center"
      }}>
        <div style={{ fontSize: "3rem", marginBottom: "0.5rem" }}>💼</div>
        <h1 style={{ fontSize: "1.45rem", fontWeight: "700", marginBottom: "0.25rem" }}>
          Books Invoicing
        </h1>
        <p style={{ color: "var(--text-dim)", fontSize: "0.85rem", marginBottom: "1.75rem" }}>
          GST Billing, Inventory Masters & Customer Ledgers
        </p>
        <LoginForm onLoginSuccess={onLoginSuccess} />
      </div>
    </div>
  );
}

export default LoginPage;
